import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams, useNavigate } from "react-router-dom";
import FAQAccMang from "./FAQPages/FAQAccMang";
import FAQKyc from "./FAQPages/FAQKyc";
import FAQCryptoDeposit from "./FAQPages/FAQCryptoDeposit";
import FAQSecurity from "./FAQPages/FAQSecurity";
import FAQEarn from "./FAQPages/FAQEarn";
import FAQApi from "./FAQPages/FAQApi";
import FAQTrading from "./FAQPages/FAQTrading";
import Footer from "../../../customComponents/Footer";

const FAQ = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [category]);

  const selectCategory = (catName) => {
    if (category === catName) {
      navigate("/help_center");
    } else {
      navigate(`/help_center/${catName}`);
    }
  };

  return (
    <>
      <Helmet>
        <title>Help Center | AGCX Support</title>
        <meta
          name="description"
          content="Find answers to common questions about deposits, withdrawals, trading, and account security on the AGCX Help Center. "
        />
        <meta
          name="keywords"
          content="AGCX help center, crypto exchange support UAE "
        />
        <link rel="canonical" href="https://arabglobal.ae/help_center" />
      </Helmet>

      <section className="inner-page-banner pb-0"></section>

      {category ? (
        /* 1. SIDEBAR DETAIL VIEW FOR SELECTED CATEGORY */
        <section className="faq_cards help_center_faq_cards">
          <div className="container">
            <h1 className="text-center mb-5">
              <img
                src="/images/AnnouncementImg/back_btn.png"
                alt="back btn"
                style={{ cursor: "pointer", marginRight: "15px", verticalAlign: "middle", height: "30px" }}
                onClick={() => navigate("/help_center")}
              />
              Have any questions? We’re here to assist you
            </h1>

            <div className="row">
              <div className="col-lg-4">
                <div className="grid faq_sidebar">
                  <a
                    className={category === "faqAccountManagment" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("faqAccountManagment");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq1.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>Account Management</h5>
                      <p>Help for your profile related queries</p>
                    </div>
                  </a>
                  {isMobile && category === "faqAccountManagment" && <FAQAccMang />}

                  <a
                    className={category === "FAQKyc" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("FAQKyc");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq2.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>Know Your Customer(KYC)</h5>
                      <p> Know all about KYC and its process </p>
                    </div>
                  </a>
                  {isMobile && category === "FAQKyc" && <FAQKyc />}

                  <a
                    className={category === "FAQCryptoDeposit" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("FAQCryptoDeposit");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq3.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>Cypto Deposit And Withdrawal</h5>
                      <p> Help for deposit & withdrawal of crypto </p>
                    </div>
                  </a>
                  {isMobile && category === "FAQCryptoDeposit" && <FAQCryptoDeposit />}

                  <a
                    className={category === "FAQSecurity" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("FAQSecurity");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq4.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>Security</h5>
                      <p> Guidelines for your profile security </p>
                    </div>
                  </a>
                  {isMobile && category === "FAQSecurity" && <FAQSecurity />}

                  <a
                    className={category === "FAQEarn" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("FAQEarn");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq5.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>Earn </h5>
                      <p> All about Refer & Earn, Airdrops</p>
                    </div>
                  </a>
                  {isMobile && category === "FAQEarn" && <FAQEarn />}

                  <a
                    className={category === "FAQApi" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("FAQApi");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq6.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>API</h5>
                      <p>About AGCX API services </p>
                    </div>
                  </a>
                  {isMobile && category === "FAQApi" && <FAQApi />}

                  <a
                    className={category === "FAQTrading" ? "card active" : "card"}
                    href="#/"
                    onClick={(e) => {
                      e.preventDefault();
                      selectCategory("FAQTrading");
                    }}
                  >
                    <div className="doc_icon">
                      <img src="/images/faq7.png" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>Trading with AGCX</h5>
                      <p> Help for all your trading transactions </p>
                    </div>
                  </a>
                  {isMobile && category === "FAQTrading" && <FAQTrading />}
                </div>
              </div>

              {!isMobile && (
                <>
                  {category === "faqAccountManagment" && <FAQAccMang />}
                  {category === "FAQKyc" && <FAQKyc />}
                  {category === "FAQCryptoDeposit" && <FAQCryptoDeposit />}
                  {category === "FAQSecurity" && <FAQSecurity />}
                  {category === "FAQEarn" && <FAQEarn />}
                  {category === "FAQApi" && <FAQApi />}
                  {category === "FAQTrading" && <FAQTrading />}
                </>
              )}
            </div>
          </div>
        </section>
      ) : (
        /* 2. MAIN CATEGORIES GRID VIEW */
        <>
          <div className="hero-banner-style top-section-gap help_sectionbl">
            <section className="faq_sec">
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-8 col-md-12">
                    <div className="section-title">
                      <h1 className="text-gradient text-center">
                        Have any questions? We’re here to assist you
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section className="faq_cards help_center_faq_cards">
            <div className="container">
              <div className="grid">
                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("faqAccountManagment");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq1.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>Account Management</h5>
                    <p>Help for your profile related queries</p>
                  </div>
                </a>

                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("FAQKyc");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq2.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>Know Your Customer(KYC)</h5>
                    <p> Know all about KYC and its process </p>
                  </div>
                </a>

                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("FAQCryptoDeposit");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq3.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>Crypto Deposit And Withdrawal</h5>
                    <p> Help for deposit & withdrawal of crypto </p>
                  </div>
                </a>

                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("FAQSecurity");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq4.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>Security</h5>
                    <p> Guidelines for your profile security </p>
                  </div>
                </a>

                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("FAQEarn");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq5.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>Earn </h5>
                    <p> All about Refer & Earn, Airdrops</p>
                  </div>
                </a>

                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("FAQApi");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq6.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>API</h5>
                    <p>About AGCX API services </p>
                  </div>
                </a>

                <a
                  className="card"
                  href="#/"
                  onClick={(e) => {
                    e.preventDefault();
                    selectCategory("FAQTrading");
                  }}
                >
                  <div className="doc_icon">
                    <img src="/images/faq7.png" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>Trading with AGCX</h5>
                    <p> Help for all your trading transactions </p>
                  </div>
                </a>
              </div>
            </div>
          </section>
        </>
      )}

      <Footer />
    </>
  );
};

export default FAQ;
